import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import scooter from '../../img/scooter.jpg'
import scooterFont from '../../img/scooterFont.jpg'
import scooterScr from '../../img/scooterscr.jpg'

function Scooter() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className='container'>
      <MainTitle title={t('scooterTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="scooterDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={scooterFont} alt="Typescale" />
          <figcaption>Scooter font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#1E2025"}}></span> #1E2025</li>
          <li><span className='color' style={{background: "#353B43"}}></span> #353B43</li>
          <li><span className='color' style={{background: "#C6CACF"}}></span> #C6CACF</li>
          <li><span className='color' style={{background: "#23B33A"}}></span> #23B33A</li>
          <li><span className='color' style={{background: "#1C912F"}}></span> #1C912F</li>
          <li><span className='color' style={{background: "#FFE120"}}></span> #FFE120</li>
          <li><span className='color' style={{background: "#FFEA62"}}></span> #FFEA62</li>
          <li><span className='color' style={{background: "#F2F5F7"}}></span> #F2F5F7</li>
        </ul>
        
        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="scooterDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="scooterUXTxt" components={{ul: <ul />, li: <li />}}>
        The main UX goal was to simplify the browsing experience and help users quickly find relevant scooter models, rental information, and key specifications without overwhelming them with technical details.
        <br /><br />Special attention was given to:
        <ul>
          <li>clear navigation structure</li>
          <li>readable content sections</li>
          <li>strong call-to-action placement</li>
          <li>mobile responsiveness</li>
          <li>fast information scanning</li>
        </ul>
        The layout was designed to guide users naturally through the website while maintaining a modern and engaging visual flow.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="scooterVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={scooterScr} alt={t('figmaScr')} />
          <figcaption>{t('scooterScrCaption')}</figcaption>
        </figure>
        
        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="scooterFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://stscooter.com/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Scooter

function ContentOne() {
  return(
    <img className="image-fluid" src={scooter} alt="STScooter" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('scooterMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://stscooter.com/"} disabled target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="scooterMainText2">
        The main problem to solve was: <br/><i>How to make it easier for the user to find a perfect scooter to scoot the city of Split.</i>
      </Trans></p>
    </div>
  );
}